import { reducer as reduxFormReducer } from '@deecide/redux-form';

export const SET_VALUES_ACTION = '@@REDUX_JSON_FORM/SET_VALUES';
export const CLEAR_SYNC_ERRORS = '@@REDUX_JSON_FORM/CLEAR_SYNC_ERRORS';

export const setReduxJsonFormValues = (form, data) => {
  return {
    type: SET_VALUES_ACTION,
    data,
    meta: { form },
  };
};

export const clearSyncErrors = (form) => {
  return {
    type: CLEAR_SYNC_ERRORS,
    data: {},
    meta: { form },
  };
};

export const reduxJsonFormReducer = (state, action) => {
  if (action.type === SET_VALUES_ACTION) {
    const form = action && action.meta && action.meta.form;
    if (!form || !state[form] || !state[form].values) return state;
    return reduxFormReducer(
      {
        ...state,
        [form]: {
          ...state[form],
          values: {
            ...state[form].values,
            ...action.data,
          },
        },
      },
      action,
    );
  }
  if (action.type === CLEAR_SYNC_ERRORS) {
    const form = action && action.meta && action.meta.form;
    if (!form || !state[form] || !state[form].values) return state;
    return reduxFormReducer(
      {
        ...state,
        [form]: {
          ...state[form],
          syncErrors: {},
        },
      },
      action,
    );
  }
  return reduxFormReducer(state, action);
};
